const AuthChecker = (document) => {
    return new Blob([`let timerInterval = 900000;

    function GetTokenCookie(cookieName) {
        var name = cookieName + "=";
        var decodedCookie = '${decodeURIComponent(document.cookie)}';
        var ca = decodedCookie.split(';');
        var cookieValueToReturn = "";
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                cookieValueToReturn = c.substring(name.length, c.length);
            }
        }
        return cookieValueToReturn;
    }

    timerFunc = () => {
            let test = GetTokenCookie("mtjwt");
            self.postMessage(test != '');
    };
setInterval(timerFunc, timerInterval);
`], { type: 'text/javascript' });
};

export default AuthChecker;
